var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.061,
    height: 14.061,
    viewBox: "0 0 14.061 14.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    transform: "translate(-56 -334.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "inventory_2_FILL0_wght400_GRAD0_opsz48_1_",
    "data-name": "inventory_2_FILL0_wght400_GRAD0_opsz48 (1)",
    d: "M4.7,16.971V8.324a.756.756,0,0,1-.475-.352A1.147,1.147,0,0,1,4,7.287V5.055a1.022,1.022,0,0,1,.316-.729A1,1,0,0,1,5.055,4H17.006a1.009,1.009,0,0,1,.729.325,1.009,1.009,0,0,1,.325.729V7.287a1.147,1.147,0,0,1-.228.685.756.756,0,0,1-.475.352v8.648a1.067,1.067,0,0,1-.325.747.986.986,0,0,1-.729.343H5.758a.976.976,0,0,1-.738-.343A1.081,1.081,0,0,1,4.7,16.971Zm1.055-8.63v8.665H16.3V8.341ZM17.006,7.287V5.055H5.055V7.287ZM8.921,12.032H13.14V10.978H8.921ZM5.758,17.006v0Z",
    transform: "translate(52 330.97)",
    fill: "#9bacb1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.76cc75c941d358dd1095e94036b09641.svg";
export { ForwardRef as ReactComponent };